import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { finalize, takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services';
import { BoltType } from '../../../enums/bolt-type.enum';
import { StandardModel } from '../../../models';
import { Router } from '@angular/router';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { Subject } from 'rxjs';
import { CalculationType } from '../../../enums/calculation-type.enum';

@Component({
    selector: 'app-standard',
    templateUrl: './standard.component.html',
    styleUrls: ['./standard.component.scss'],
})
export class StandardComponent implements OnInit, OnDestroy {
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Input()
    set isCustom(value: boolean) {
        this._isCustom = value;
        this.getStandards();
    }
    get isCustom(): boolean {
        return this._isCustom;
    }

    @Output() selected: EventEmitter<StandardModel> = new EventEmitter();
    @Output() defaultBoltType: EventEmitter<BoltType> = new EventEmitter();
    destroy$ = new Subject();

    tooltip_position = 'above';
    loading: boolean = false;
    standardList: StandardModel[];
    private _isCustom: boolean = false;

    constructor(
        private iceapi: IceapiService,
        private dataService: DataService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        private router: Router,
        private jointCalcService: JointCalcService
    ) {}

    ngOnInit(): void {
        this.form.markAllAsTouched();

        if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
            this.pipespecwithstandard();
        } else if (!this.jointCalcService.isPipeCode) {
            this.getStandards();
        }

        if (this._isCustom === false) {
            this.form
                .get('standard')
                .valueChanges.pipe(takeUntil(this.destroy$))
                .subscribe((value) => {
                    if (value) {
                        if (
                            (this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) &&
                            this.jointCalcService.isPipeCode
                        ) {
                            this.jointCalcService.selectedStandard.next(this.form.get('standard').value);
                        } else if (!this.jointCalcService.isPipeCode) {
                            this.setDefaultBoltType(value);
                        }
                    }
                });
        }
    }

    getStandards(): void {
        if (this.isCustom != true) {
            this.loading = true;
            this.iceapi
                .getStandards()
                .pipe(
                    finalize(() => {
                        this.loading = false;
                    })
                )
                .pipe(takeUntil(this.destroy$))
                .subscribe((standardModels) => {
                    if (standardModels.success === true) {
                        this.dataService.selectedStandardCalcMode = null;
                        this.standardList = standardModels.response;
                        if (this.standardList.length === 1) this.form.get('standard').setValue(this.standardList[0].standardId);
                        this.cd.markForCheck();
                        if (this.form.get('standard').value) {
                            this.dataService.selectedStandard = this.standardList.find((x) => x.standardId === this.form.get('standard').value).standardName;
                            this.dataService.selectedStandardCalcMode = this.standardList.find(
                                (x) => x.standardId === this.form.get('standard').value
                            ).calcMode;
                            this.dataService.isStandardCalcMode.next(true);
                        }
                    } else {
                        this.user_utility.errorModelPopup(standardModels.message);
                    }
                });
        }
    }

    selectStandard(selectedValue: MatSelectChange): void {
        const selection = this.standardList.find((x) => x.standardId === selectedValue.value);
        if (selection) {
            this.selected.emit(selection);
            this.dataService.selectedStandard = selection.standardName;
            this.dataService.selectedStandardCalcMode = selection.calcMode;
            this.dataService.isStandardCalcMode.next(true);
        }
    }

    setDefaultBoltType(value: string) {
        this.defaultBoltType.emit(this.standardList.find((x) => x.standardId === value).defaultBoltType as BoltType);
    }

    async pipespecwithstandard() {
        this.jointCalcService.selectedLubricant.pipe(takeUntil(this.destroy$)).subscribe(async (lub) => {
            this.loading = true;
            if (lub && this.jointCalcService.pipeSpecpayload.lookupParams.calculationType == CalculationType.StandardFlange) {
                let pipeSpecStandard = await this.iceapi
                    .getStandards()
                    .pipe(finalize(() => (this.loading = false)))
                    .toPromise();

                if (pipeSpecStandard.success) {
                    this.standardList = pipeSpecStandard.response;

                    let InputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;
                    InputGroup.recordId.lubricantId = lub;
                    InputGroup.nominal =
                        InputGroup.recordId.standardId =
                        InputGroup.recordId.flangeTypeId =
                        InputGroup.recordId.flangeFacingTypeId =
                        InputGroup.recordId.flangeMaterialId =
                        InputGroup.recordId.gasketId =
                        InputGroup.others.boltType =
                        InputGroup.recordId.boltMaterialId =
                        InputGroup.others.tighteningSpecification =
                            null;

                    // this.jointCalcService.filterList(this.jointCalcService.pipeSpecpayload.lookupParams);
                    // console.log('_______________________***********', this.jointCalcService.filterList(this.jointCalcService.pipeSpecpayload.lookupParams));

                    this.standardList = await this.jointCalcService.managePayloadForRecourdId('standardId', this.standardList);

                    if (this.dataService?.calculationData?.input?.recordId?.standardId)
                        this.form.get('standard').setValue(this.dataService?.calculationData?.input?.recordId?.standardId);
                    else if (this.standardList.length === 1) this.form.get('standard').setValue(this.standardList[0].standardId);
                } else if (pipeSpecStandard.isCustom) {
                    this.user_utility.errorModelPopup(pipeSpecStandard.message);
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
